import React from "react";
import ProductPage from "./components/ProductPage";
import getFavItems from "../favourites/utils/getFavItems";
import {createRoot} from "react-dom/client";

export default () => {
    const dom = document.querySelector('[data-product-page]');
    if (dom) {
        const json = JSON.parse(dom.getAttribute('data-product-page'));
        const stockists = JSON.parse(dom.getAttribute('data-stockist'));
        const root = createRoot(dom);
        getFavItems().then((data) => {
            root.render(
                <ProductPage
                    product={json}
                    stockists={stockists}
                />
            );
        });
    }

}
